import { useActiveTabFromMatch } from "@shared";

import { AppRoutes } from "@/router/AppRoutes";
import { SystemSettingsTab } from "@/router/SystemSettingsRoutes";

/**
 * Resolves the active side-navigation tab of a Systemeinstellungen (system settings) detail page from
 * the URL (`/system-settings/<section>/:id/:tab`). `tabs` is the section's tab enum, and only a
 * segment that is one of its values is returned — an unknown segment leaves no tab selected.
 */
export function useActiveDetailTab<TTab extends string>(
  section: SystemSettingsTab,
  tabs: Record<string, TTab>
): TTab | undefined {
  return useActiveTabFromMatch(`${AppRoutes.SystemSettings}/${section}/:id/:tab`, tabs);
}
